import { classNameType } from "@/types/generalTypes";
import React from "react";


function Store({ className }: classNameType) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 15 15"
      fill="none"
      className={className}
    >
      <path
        d="M11.7571 14.3869C11.4728 14.3869 11.2422 14.1564 11.2422 13.8721C11.2422 13.5877 11.4728 13.3572 11.7571 13.3572C12.0415 13.3572 12.272 13.5877 12.272 13.8721C12.272 14.1564 12.0415 14.3869 11.7571 14.3869Z"
        fill="#333333"
        stroke="#333333"
        strokeWidth="0.89"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.06347 14.3869C4.77911 14.3869 4.54858 14.1564 4.54858 13.8721C4.54858 13.5877 4.77911 13.3572 5.06347 13.3572C5.34784 13.3572 5.57835 13.5877 5.57835 13.8721C5.57835 14.1564 5.34784 14.3869 5.06347 14.3869Z"
        fill="#333333"
        stroke="#333333"
        strokeWidth="0.89"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3754 7.17871H7.28613"
        stroke="#333333"
        strokeWidth="0.89"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.83105 5.63379V8.7231"
        stroke="#333333"
        strokeWidth="0.89"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 1H3.57442L3.84542 3.57442M3.84542 3.57442L4.50715 9.86084C4.56231 10.3849 5.00426 10.7828 5.53125 10.7828H12.0383C12.5109 10.7828 12.9228 10.4612 13.0374 10.0028L14.3246 4.85395C14.4871 4.20401 13.9955 3.57442 13.3255 3.57442H3.84542Z"
        stroke="#333333"
        strokeWidth="0.89"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Store;
